import { useClerk } from "@clerk/clerk-react";

/**
 * Shown to a signed-in user who is not an invited app user (employee.is_user === false,
 * or no matching employee record). Gives instructions to request access and a way to
 * sign out so a different account can be used.
 */
export function NoAccess() {
  const { signOut } = useClerk();

  return (
    <main className="access-screen">
      <div className="access-screen__card">
        <div className="brand-logo" aria-hidden>
          <img src="/public/capacitor-logo.svg" alt="Capacitor Logo" />
        </div>
        <h1 className="access-screen__title">Access required</h1>
        <p className="access-screen__message">
          Your account doesn&apos;t have access to Capacitor yet. To request
          access, reach out to your Capacitor admins.
        </p>
        <button
          type="button"
          className="secondary-button"
          onClick={() => signOut()}
        >
          Sign out
        </button>
      </div>
    </main>
  );
}
